import React, { useEffect, useRef } from 'react'
import ReactDOM from 'react-dom'
import { useSpring, animated } from '@react-spring/web'
import styled from 'styled-components'
import { Text } from '../../modules/Dashboard'
import { ScrollWrap } from '../../styles/responsive/Common'
import useClickOutside from '../../core/hooks/useClickOutside'

export default function MobileModal({ isOpen, children, onClose, title = undefined, animationConfig, noPadding = false, noBg = false }) {
    const modalRoot = document.getElementById('mobile-modal-root')
    const modalRef = useRef()
    const ignoredRef = useRef()

    const animation = useSpring({
        opacity: isOpen ? 1 : 0,
        transform: isOpen ? `translateY(0%)` : `translateY(100%)`,
        config: { tension: 300, friction: 30, ...animationConfig },
    })

    useClickOutside(modalRef, null, onClose)

    useEffect(() => {
        // Lock body scroll when modal is open
        if (isOpen) {
            document.body.style.overflow = 'hidden'
        } else {
            document.body.style.overflow = 'auto'
        }

        return () => document.body.style.overflow = 'auto'

    }, [isOpen])

    if (!isOpen) return null

    return ReactDOM.createPortal(
        <Overlay>
            <animated.div style={animation}>
                <ModalWrapper noPadding={noPadding} noBg={noBg}>
                    {
                        noBg ? null :
                            <NotchWrapper >
                                <Notch />
                            </NotchWrapper>
                    }
                    {
                        title &&
                        <Header>
                            <Text tid={title} className='text-xl' />
                        </Header>
                    }
                    <ScrollWrap maxHeight='60vh' ref={modalRef}>
                        {children}
                    </ScrollWrap>
                </ModalWrapper>
            </animated.div>
        </Overlay>,
        modalRoot
    )
}

const Overlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    /* background: ${props => props.theme.modalBg}90; */
    backdrop-filter: blur(3px);
    -webkit-backdrop-filter: blur(3px);
    display: flex;
    justify-content: center;
    align-items: flex-end;
    z-index: 99999;
    color: #FFFFFF;
    font-family: ${(props) => (props.theme.english ? 'Metrophobic' : 'Kalameh')};
`

const ModalWrapper = styled.div`
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    width: 100vw;
    max-height: 90vh;
    overflow-y: auto;
    position: relative;
    padding-inline: ${props => props.noPadding ? "" : "20px"};
    padding-block: ${props => props.noPadding ? "10px 0" : "10px 30px"};
    background-color: ${props => props.noBg ? "" : props.theme.modalBg};
    backdrop-filter: blur(5px);
    -webkit-backdrop-filter: blur(5px);
`
const NotchWrapper = styled.div`
    display: flex;
    justify-content: center;
    margin-bottom: 1rem;
`

const Notch = styled.div`
    width: 60px;
    height: 5px;
    border-radius: 20px;
    background-color: #a6b1bf;
`

const Header = styled.div`
    padding: 8px 0;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
`